import React from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from '@fluentui/react-components';
import { Delete24Regular } from '@fluentui/react-icons';
import { ChatParticipantResponse } from '@mnspro-cloud/services/lib/mnspro-cloud/api/v2';
import { Button } from '../../Button';
import { ChatStudentBadge } from '../ChatBadge/ChatStudentBadge';
import './ChatSettings.scss';

interface ChatSettingsParticipantParentProps {
  parent: ChatParticipantResponse;
  onDeleteClick?: (userId: string) => void;
}

export const ChatSettingsParticipantParent: React.FC<ChatSettingsParticipantParentProps> = ({
  parent,
  onDeleteClick,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-row gap-1 items-center">
      {parent.wards.map((ward) => (
        <ChatStudentBadge key={ward.id} userId={ward.id} displayName={ward.displayName} />
      ))}
      <Text className="flex-1">{parent.displayName}</Text>
      <Button
        icon={<Delete24Regular />}
        appearance="transparent"
        className="primaryBtn"
        aria-label={t('pc:chat:settings:remove_participant_aria', {
          defaultValue: '{{name}} aus dem Chat entfernen',
          name: parent.displayName,
        })}
        onClick={() => onDeleteClick && onDeleteClick(parent.userId)}
      />
    </div>
  );
};
